import { useTranslation } from 'react-i18next';

export const useErrorMessageHandler = () => {
  const { t } = useTranslation();

  const getErrorMessage = (err: any) => {
    if (!err) return null;
    if (Array.isArray(err)) {
      return err[0];
    } else if (typeof err === 'string') {
      return t(err);
    } else {
      return t(err.key, err.values);
    }
  };
  return { getErrorMessage };
};